import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePagetwo from "../Components/NabBarLinks/Homepagetwo";
import Aboutus from "../Components/NabBarLinks/AboutPage";
import ContactUs from "../Components/NabBarLinks/ContactUsPage";
import PreAndPostOnboarding from "../Components/OurService/PreAndPostOnboarding";
import Payroll from "../Components/OurService/Payroll";
import EmployeeEngagement from "../Components/OurService/EmployeeEngagement";
import EmployeeBenefitsAndWellnessPortal from "../Components/OurService/EmployeeBenefitsAndWellnessPortal";
import PerformanceManagement from "../Components/OurService/PerformanceManagement";
import StatutoryAndCompliance from "../Components/OurService/StatutoryAndCompliance";
import ExecutiveHiring from "../Components/OurService/ExecutiveHiring";
import Facilitation from "../Components/OurService/Facilitation";
import ExecutiveCoaching from "../Components/OurService/ExecutiveCoaching";
import Footer from "../Components/Navigation/Footer";
import Navbartwo from "../Components/Navigation/Navbartwo"
import AIPoweredPsychometricTests from "../Components/OurService/AIPoweredPsychometricTests"
import PersonalCounselling from "../Components/OurService/PersonalCounselling"
import SkillBuilding from "../Components/OurService/SkillBuilding"
import FinancialPlanning from "../Components/OurService/FinancialPlanning"
import StudyAbroad from "../Components/OurService/StudyAbroad"
import CareerLibrary from "../Components/OurService/CareerLibrary"
import TeamBuilding from "../Components/OurService/TeamBuilding"


function PageRouter() {
  return (
    
    <Router>
      <Navbartwo/>
      <Routes>
        <Route path="/" element={<HomePagetwo />} />
        <Route path="/aboutus" element={<Aboutus />} />
        <Route path="/contactus" element={<ContactUs />} />
        
        <Route
          path="/PreAndPostOnboarding"
          element={<PreAndPostOnboarding />}
        />
        <Route path="/Payroll" element={<Payroll />} />
        <Route path="/EmployeeEngagement" element={<EmployeeEngagement />} />
        <Route
          path="/EmployeeBenefitsAndWellnessPortal"
          element={<EmployeeBenefitsAndWellnessPortal />}
        />
        <Route
          path="/PerformanceManagement"
          element={<PerformanceManagement />}
        />
        
        <Route
          path="/StatutoryAndCompliance"
          element={<StatutoryAndCompliance />}
        />
        <Route path="/ExecutiveHiring" element={<ExecutiveHiring />} />
        <Route path="/ExecutiveCoaching" element={<Facilitation />} />
        <Route path="/CareerTransition" element={<ExecutiveCoaching />} />
        <Route path="/AIpsychotest" element={<AIPoweredPsychometricTests />} />
        <Route path="/PersonalCounselling" element={<PersonalCounselling/>} />
        <Route path="/SkillBuilding" element={<SkillBuilding/>} />
        {/* <Route path="/ExamPrep" element={<ExamPrep/>} /> */}
        <Route path="/FinancialPlanning" element={<FinancialPlanning/>} />
        <Route path="/StudyAbroad" element={<StudyAbroad/>} />
        <Route path="/CareerLibrary" element={<CareerLibrary/>} />
        <Route path="/Teambuilding" element={<TeamBuilding/>} />
      </Routes>

      

      <Footer/>
    </Router>
    
  );
}

export default PageRouter;
